module.exports = __webpack_public_path__ + "files/85a1d08984c9ad51b8f04836a30b7fca.png";